<template>
  <b-modal
    id="location-permission-modal"
    v-model="visible"
    centered
    hide-header
    hide-footer
    size="sm"
    modal-class="permission-modal"
  >
    <div class="text-center p-3">
      <div class="icon-circle mb-3">
        <i class="fas fa-map-marker-alt fa-2x text-primary"></i>
      </div>

      <h5 class="mb-2 font-weight-bold text-uppercase">
        {{$t('menuOrder.modal.error.title') }}
      </h5>

      <p class="text-dark mt-3 font-size-12 small mb-4">
        {{$t('menuOrder.modal.error.description') }}
      </p>

      <div class="d-flex flex-column">
        <b-button variant="primary" class="action-btn font-weight-bold" @click="closeModal">
          {{$t('menuOrder.modal.error.button') }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "LocationPermissionModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.show,
    };
  },
  watch: {
    show(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit("update:show", val);
    },
  },
  methods: {
    closeModal() {
      this.visible = false;
      this.$emit("refreshLocation")
    },
  },
};
</script>

<style scoped>
.permission-modal .modal-content {
  border-radius: 1rem;
  background: #fff;
  border: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.icon-circle {
  width: 60px;
  height: 60px;
  background: #e8f0ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

h5 {
  font-size: 1rem;
  color: #222;
}

.action-btn {
  font-size: 0.95rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  font-weight: 500;
}
</style>
